<template>
	<section class="app-container">
		<TestRunner />
	</section>
</template>

<script>
import TestRunner from './TestRunner';

export default {
	name: 'TestRunnerWrapper',
	components: {
		TestRunner
	},
};
</script>